import { CommonModule } from '@angular/common';
import { Component, computed, inject, OnInit } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { PATROL_COMMUNITY_SOURCES } from '../../constants/patrol-community-sources.constants';
import { PatrolCommunitySourceCardComponent } from '../../components/patrol-community-source-card/patrol-community-source-card.component';
import { PatrolCommunitySourceId } from '../../models/patrol-community-source.model';
import { PatrolCommunitySourcesService } from '../../services/patrol-community-sources.service';
import { PatrolPlatformFlagsService } from '../../services/patrol-platform-flags.service';

@Component({
  selector: 'app-patrol-setup',
  standalone: true,
  imports: [CommonModule, TranslatePipe, PatrolCommunitySourceCardComponent],
  templateUrl: './patrol-setup.component.html',
  styleUrl: './patrol-setup.component.scss',
})
export class PatrolSetupComponent implements OnInit {
  #sourcesService = inject(PatrolCommunitySourcesService);
  #platformFlags = inject(PatrolPlatformFlagsService);

  readonly enabledSources = this.#sourcesService.enabled;

  readonly visibleSources = computed(() =>
    PATROL_COMMUNITY_SOURCES.filter((source) => {
      if (source.id === 'minecraft') {
        return true;
      }
      return this.#platformFlags.isGloballyEnabled(source.id);
    }),
  );

  ngOnInit(): void {
    void this.#platformFlags.whenReady();
  }

  onSourceToggled(sourceId: PatrolCommunitySourceId, enabled: boolean): void {
    this.#sourcesService.setEnabled(sourceId, enabled);
  }
}
